export default "__VITE_ASSET__qPC2UsV0__"